// extracted by mini-css-extract-plugin
export default {"container":"ManageReleasePage_container__A5usp","subtitle":"ManageReleasePage_subtitle__kAfQO","content":"ManageReleasePage_content__HINvb"};